import PropTypes from "prop-types";
import * as React from "react";
import { Influencer } from "../../../domain";
import * as constants from "../constants";
import ProductCard from "./ProductCard";
import ShopCard from "./ShopCard";
import sectionCss from "./Section.module.css";
import css from "./ShopsSlider.module.css";

const DEFAULT_PAGE_SIZE = 16;

export default function SectionExpanded({
  products = [],
  influencers = [],
  updateFavouriteStatus,
  look = constants.LOOK_TALL,
  isMobile,
}) {
  const [numberToShow, setNumberToShow] = React.useState(DEFAULT_PAGE_SIZE);

  const Component =
    constants.isProduct(look) || products?.length ? ProductCard : ShopCard;

  const data = products?.length ? products : influencers;

  const dataLength = data.length - 1;

  return (
    <>
      <div className={css.expanded}>
        {data.slice(0, numberToShow).map((datum) => (
          <Component
            style={{
              width: constants.cardWidthFor({ isMobile, look }),
              position: "relative",
            }}
            isMobile={isMobile}
            data={datum}
            updateFavouriteStatus={updateFavouriteStatus}
            look={look}
            key={datum.route}
            isExpanded
          />
        ))}
      </div>

      {numberToShow < dataLength && (
        <div className={sectionCss.flexCenter}>
          <button
            className={sectionCss.textButton}
            onClick={() =>
              setNumberToShow((ns) =>
                Math.min(ns + DEFAULT_PAGE_SIZE, dataLength),
              )
            }
          >
            View More
          </button>
        </div>
      )}
    </>
  );
}

SectionExpanded.propTypes = {
  products: PropTypes.array,
  influencers: PropTypes.arrayOf(PropTypes.instanceOf(Influencer)),
  updateFavouriteStatus: PropTypes.func,
  look: PropTypes.oneOf(["tall"]),
  isMobile: PropTypes.bool,
};
